import {useMemo} from 'react';

import {addGenericErrorToast} from '@albert-io/atomic';
import getClassroomInvitationsQuery from '../queries/getClassroomInvitationsQuery';
import {useStudentDashboard} from 'client/Classrooms/StudentDashboard/StudentDashboard.store';

export default function useClassroomInvitations() {
  const areInvitationsLoading = useStudentDashboard((state) => state.areInvitationsLoading);
  const invitations = useStudentDashboard((state) => state.invitations);
  const setAreInvitationsLoading = useStudentDashboard((state) => state.setAreInvitationsLoading);
  const setInvitations = useStudentDashboard((state) => state.setInvitations);
  const studentEmail = useStudentDashboard((state) => state.student?.getEmail() ?? '');

  const query = useMemo(() => getClassroomInvitationsQuery(studentEmail), [studentEmail]);

  function fetchClassroomInvitations() {
    setAreInvitationsLoading(true);

    query.invalidateInterest();

    query
      .getResourcePromise()
      .then((fetchedInvitations) => {
        setInvitations(fetchedInvitations);
      })
      .catch((error) => {
        console.error(error);
        addGenericErrorToast();
      })
      .finally(() => {
        setAreInvitationsLoading(false);
      });
  }

  return {areInvitationsLoading, fetchClassroomInvitations, invitations};
}
